import { CreditCardComponent } from "src/app/components/global-payment/credit-card/credit-card.component";
import { UpiComponent } from "src/app/components/global-payment/upi/upi.component";


export const PaymentComponentMap: { [key: string]: any } = {
    upi_options: UpiComponent,
    credit_card: CreditCardComponent

}